import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;
const defaultCRFields = {
  _id: '',
  paymentDate: '',
  programType: '',
  workstation: '',
  paymentNumber: '',
  index: '',
  cashTotal: '',
  paymentType: '',
  amount: '',
  checkNumber: '',
  paidBy: '',
  isReconcilled: '',
  totalChange: '',
  hasFiles: '',
  order: '',
};

export const taxCheckRecon = {
  namespaced: true,
  state: () => ({
    checkReconSelItems: [],

  }),
  mutations: {
    setCheckReconSelItems(state, items) {
      state.checkReconSelItems = items;
    },
  },
  actions: {
    async loadTaxCheckRecon({ commit, dispatch }, {
      criteria, baseCrudKey, fields, postProcessTrans,
    }) {
      let results;
      const dupCriteria = { ...criteria };
      try {
        const gqlfields = fields || defaultCRFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxCRPayments($criteria: taxCRPaymentsCriteriaType) {
              taxCRPayments(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria: dupCriteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (baseCrudKey && results.data && results.data.taxCRPayments) {
          const checkReconData = postProcessTrans
            ? postProcessTrans(results.data.taxCRPayments)
            : results.data.taxCRPayments;
          commit('base/crud/setItems', [baseCrudKey, checkReconData], { root: true });
        }
        return results.data.taxCRPayments;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting check recon transactions list.', { root: true });
        return [];
      }
    },
    async upsertTaxCheckRecon({ dispatch, commit }, {
      upserts, isReconcileAll, isReconciledFlag,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxCRPayments ($upserts: [taxCRPaymentsInputType!], $isReconcileAll: Boolean, $isReconciledFlag: Boolean)  {
            upsertTaxCRPayments(upserts: $upserts, isReconcileAll: $isReconcileAll, isReconciledFlag: $isReconciledFlag) {
                  status
                  }
                }`,
          variables: {
            upserts, isReconcileAll, isReconciledFlag,
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        // the mutation only returns { status }, not a row; callers refetch the lists
        return results;
      } catch (e) {
        dispatch('logException', e, { root: true });
        dispatch('flashError', 'There was a problem upserting check recon transactions.', {
          root: true,
        });
        return [];
      }
    },
    async flagReconciledTaxCRPayments({ dispatch, commit }, {
      upserts, isReconciledFlag,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation flagReconciledTaxCRPayments ($upserts: [taxCRPaymentsInputType!], $isReconciledFlag: Boolean)  {
            flagReconciledTaxCRPayments(upserts: $upserts, isReconciledFlag: $isReconciledFlag) {
                  status
                  }
                }`,
          variables: {
            upserts, isReconciledFlag,
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        // the mutation only returns { status }, not a row; callers refetch the lists
        return results;
      } catch (e) {
        dispatch('logException', e, { root: true });
        dispatch('flashError', 'There was a problem upserting check recon transactions.', {
          root: true,
        });
        return [];
      }
    },
  },
};

export default {};
